if (!customElements.get('mini-cart')) {
  customElements.define(
    'mini-cart',
    class Minicart extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        window.addEventListener('productForm:add', e => {
          this.refreshMarkup(e?.detail?.sections?.['inner-cart']);
        });
        
        this.populateUpsells();
        
        this.addEventListener('click', (e) => {
          const clickedElement = e.target.closest('[data-cart-action]');
          if (!clickedElement) return;
  
          const {
            cartAction: action,
            lineItemId,
            quantity,
          } = clickedElement.dataset;
          
          switch (action) {
            case 'updateQty':
              this.classList.add('loading');
              
              updateQty(lineItemId, Number(quantity))
                .then((res) => {
                  window.cartPrice = res.totalPrice;
                  window.dispatchEvent(new CustomEvent('cart:update', { 
                    detail: res
                  }));
                  this.refreshMarkup(res?.sections?.['inner-cart']);
                })
                .finally(() => this.classList.remove('loading'));
            break;
            default: break;
          }
        })
      }
      
      populateUpsells() {
        const upsellTemplate = document.querySelector('template[data-cart-upsells]').cloneNode(true).content;
        const cartItemsSection = this.querySelector('[data-section="cart-upsell-items"]');
        
        if (!upsellTemplate || !cartItemsSection || this.querySelector('.upsell-header')) return;
        
        cartItemsSection.querySelectorAll('[data-cart-product-id]').forEach(cartItem => {
          const cartItemId = cartItem.dataset.cartProductId;
          const matchingProductUpsell = upsellTemplate.querySelector(`[data-upsell-product-id="${cartItemId}"]`);
          if (matchingProductUpsell) matchingProductUpsell.remove();
        });
        
        cartItemsSection.append(upsellTemplate);
      }
      
      refreshMarkup (markup) {
        if (!markup) {
          alert(`Unable to refresh your cart. Your product is added. Refresh the page to view your new cart.`)
          return;
        }
        
        const tempMarkup = document.createElement('div');
        tempMarkup.innerHTML = markup;
        
        this.querySelectorAll('[data-section]').forEach(section => {
          const sectionId = section.dataset.section;
          const newMarkup = tempMarkup.querySelector(`[data-section="${sectionId}"]`);
          if (!newMarkup) return;
          
          section.innerHTML = newMarkup.innerHTML;
        });
        
        this.populateUpsells();
      }
    }
  )
}

if (!customElements.get('cart-purchase-progress')) {
  customElements.define(
    'cart-purchase-progress',
    class CartPurchaseProgress extends HTMLElement {
      constructor() {
        super();
        this.maxThreshhold = 0;
        this.freeShippingThreshhold = null;
        this.messagingEl = this.closest('[data-progress-wrapper]')?.querySelector('[data-threshhold-messaging]');
        this.preMessagingEl = this.closest('[data-progress-wrapper]')?.querySelector('[data-threshhold-pre-messaging]');
      }
    
      connectedCallback() {        
        this.init();
        
        window.addEventListener('cart:update', e => {
          this.updateSelf(e.detail.total_price, e.detail.item_count);
          window.dispatchEvent(new CustomEvent('cart:dataChange', { 
            detail: e.detail
          }));
        });
        
        window.addEventListener('productForm:add', e => {
          this.fetchAndUpdate();          
        });
      }
      
      init () {
        if (!window.cartProgressBarVariables) {
          console.error('Minicart:CartPurchaseProgress: Unable to get settings variables. Progress bar not initiated.')
          this.closest('[data-progress-wrapper]')?.remove();
          return;
        }
                
        window.cartProgressBarVariables.forEach((tier) => {
          if ((tier.purchase_threshhold * 100) > this.maxThreshhold) this.maxThreshhold = (tier.purchase_threshhold * 100);
          const pre_threshhold_message = tier.pre_threshhold_message?.toLowerCase() ?? '';
          const post_threshhold_message = tier.post_threshhold_message?.toLowerCase() ?? '';
          if (pre_threshhold_message.includes('free shipping') || post_threshhold_message.includes('free shipping')) {
            this.freeShippingThreshhold = tier.purchase_threshhold * 100;
          }
        });
        
        this.fetchAndUpdate();          
        this.generateMarkers();
      }
      
      fetchAndUpdate = () => {
        fetch('/cart.json')
          .then(res => res.json())
          .then(res => {
            window.dispatchEvent(new CustomEvent('cart:dataChange', { 
              detail: res
            }));
            this.updateSelf(res.total_price, res.item_count);
          })
      }
      
      generateMarkers() {
        window.cartProgressBarVariables.forEach((tier) => {
          const position = ((tier.purchase_threshhold * 100) / this.maxThreshhold) * 100;
          this.insertAdjacentHTML(`beforeEnd`, `
            <span 
              data-threshhold="${(tier.purchase_threshhold * 100)}"
              style="left: ${position}%;" 
              class="transition duration-200 absolute top-1/2 border p-1 [&.active]:border-white [&.active_span]:opacity-100 border-transparent w-4 h-4 rounded-full block z-10 transform -translate-y-1/2 -translate-x-[calc(100%+8px)]"
            >
              <span class="transition duration-200 opacity-50 bg-primaryLight block w-full h-full rounded-full"
            </span>
          `);
        });
      }
      
      updateSelf (cartTotalPrice, itemCount) {
        document.querySelectorAll('[data-cart-count]').forEach(x => x.innerText = itemCount > 0 ? itemCount : '');
        const progressPercentage = Math.min((cartTotalPrice / this.maxThreshhold) * 100, 100);
        this.style.setProperty("--progress-percentage", `${progressPercentage}%`);
        
        let minimumActiveValue = this.maxThreshhold;
        let prevActiveValue = 0;
        let activeMarker = null;
        
        [...this.querySelectorAll(`[data-threshhold]`)].forEach(marker => {
          const threshhold = Number(marker.dataset.threshhold);
          if (threshhold <= minimumActiveValue && threshhold > cartTotalPrice) {
            minimumActiveValue = threshhold;
            activeMarker = marker;
          } else if (threshhold > prevActiveValue && threshhold < cartTotalPrice) {
            prevActiveValue = threshhold;
          }
        });
                
        this.querySelector(`[data-threshhold].active`)?.classList.remove('active');
        activeMarker?.classList.add('active');
        
        const activeThreshhold = window.cartProgressBarVariables.find(x => (x.purchase_threshhold * 100) === minimumActiveValue);
        const lastActiveThreshhold = window.cartProgressBarVariables.find(x => (x.purchase_threshhold * 100) === prevActiveValue);
        setTimeout(() => {
          const freeShippingEl = this.closest('mini-cart')?.querySelector('[data-free-shipping-line]');
          freeShippingEl?.classList.toggle('show', this.freeShippingThreshhold <= cartTotalPrice);
        }, 50);
        
        const difference = ((minimumActiveValue - cartTotalPrice) / 100).toFixed(2);
        if (cartTotalPrice >= this.maxThreshhold) {
          this.preMessagingEl.innerText = ``;
          this.messagingEl.innerText = activeThreshhold ? activeThreshhold.post_threshhold_message.replace('_difference_', `$${difference}`) : '';
        } else {
          this.preMessagingEl.innerText = lastActiveThreshhold ? lastActiveThreshhold.post_threshhold_message.replace('_difference_', `$${difference}`) : '';
          this.messagingEl.innerText = activeThreshhold ? activeThreshhold.pre_threshhold_message.replace('_difference_', `$${difference}`) : '';
        }
      }
    }
  )
}